module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-16 at 09.14.28.87d0d28b.png";